module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30"
  }, [_c('div', {
    staticClass: "form-left fl "
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    staticClass: "p-r-10 m-r-10 left-content  bor-r-ccc",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "功能集名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写功能集名称"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "层级",
      "label-width": "100px"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.level),
      expression: "form.level"
    }],
    domProps: {
      "value": (_vm.form.level)
    },
    on: {
      "input": function($event) {
        _vm.form.level = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("一级层级")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("二级层级")])])]), _vm._v(" "), (!_vm.id) ? _c('el-form-item', {
    attrs: {
      "label": "复制配置"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cloneId),
      expression: "cloneId"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "选择功能集"
    },
    domProps: {
      "value": (_vm.cloneId)
    },
    on: {
      "input": function($event) {
        _vm.cloneId = $event
      }
    }
  }, _vm._l((_vm.configs), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cloneConfig
    }
  }, [_vm._v("复制")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecondLevel),
      expression: "isSecondLevel"
    }],
    attrs: {
      "label": "功能集布局配置",
      "prop": "tab"
    }
  }, [_c('content-table', {
    ref: "contentTable",
    attrs: {
      "content": _vm.form.content,
      "contentsById": _vm.contentsById
    },
    on: {
      "setCurContent": _vm.setCurContent,
      "deleteContent": _vm.deleteContent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 tx-c"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("添加内容")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单配置",
      "prop": "list_config"
    }
  }, [_c('menu-table', {
    ref: "menuTable",
    attrs: {
      "menu": _vm.form.menu,
      "menusById": _vm.menusById
    },
    on: {
      "deleteMenu": _vm.deleteMenu,
      "resetMenu": _vm.resetMenu,
      "setCurMenu": _vm.setCurMenu
    }
  }), _vm._v(" "), (!_vm.hasMenu) ? _c('div', {
    staticClass: "m-t-10 tx-c"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_vm._v("添加菜单")])]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSecondLevel),
      expression: "!isSecondLevel"
    }],
    attrs: {
      "label": "功能点配置",
      "prop": "deal"
    }
  }, [_c('deal-table', {
    ref: "dealTable",
    attrs: {
      "deal": _vm.form.deal,
      "modelsById": _vm.modelsById
    },
    on: {
      "deleteOperation": _vm.deleteOperation,
      "setCurOperation": _vm.setCurOperation,
      "cloneOperation": _vm.cloneOperation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 tx-c"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addOPeration
    }
  }, [_vm._v("添加功能点")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认字段依赖",
      "label-width": "100px"
    }
  }, [_vm._l((_vm.form.rely_field), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10 ovf-hd"
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.field_id),
        expression: "item.field_id"
      }],
      staticClass: "fl w-200 m-r-10",
      attrs: {
        "placeholder": "字段"
      },
      domProps: {
        "value": (item.field_id)
      },
      on: {
        "input": function($event) {
          item.field_id = $event
        }
      }
    }, _vm._l((_vm.fieldOptions), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.field + '(' + option.title + ')',
          "value": option.field_id
        }
      })
    })), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "w-150 m-r-10 fl",
      attrs: {
        "placeholder": "值"
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          item.value = $event
        }
      }
    }), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.type),
        expression: "item.type"
      }],
      staticClass: "fl w-200",
      attrs: {
        "placeholder": "作用范围",
        "multiple": ""
      },
      domProps: {
        "value": (item.type)
      },
      on: {
        "input": function($event) {
          item.type = $event
        }
      }
    }, _vm._l((_vm.effectRangeOptions), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    })), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteRely(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addRely
    }
  }, [_vm._v("添加默认字段依赖")])])], true), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-right"
  }, [_c('deal-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.configType == 1),
      expression: "configType == 1"
    }],
    staticClass: "fl",
    attrs: {
      "form": _vm.curOperation,
      "models": _vm.models
    },
    on: {
      "openRule": _vm.openRule,
      "formChange": _vm.formChange
    }
  }), _vm._v(" "), _c('menu-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.configType == 2),
      expression: "configType == 2"
    }],
    staticClass: "fl",
    attrs: {
      "menus": _vm.menus,
      "form": _vm.curMenu
    },
    on: {
      "openRule": _vm.openRule
    }
  }), _vm._v(" "), _c('content-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.configType == 3),
      expression: "configType == 3"
    }],
    staticClass: "fl",
    attrs: {
      "contents": _vm.contents,
      "form": _vm.curContent
    },
    on: {
      "openRule": _vm.openRule
    }
  }), _vm._v(" "), _c('rule-list', {
    ref: "ruleList",
    attrs: {
      "title": _vm.title
    },
    on: {
      "selectRule": _vm.selectRule
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8a9f4f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/form.vue
// module id = 1972
// module chunks = 2